import { ChangeDetectorRef, NgZone } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

export abstract class BaseToastComponent extends Toast {
  public originalTimeOut: number = 0;
  protected cdr?: ChangeDetectorRef;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    cdr?: ChangeDetectorRef,
    ngZone?: NgZone
  ) {
    super();
    this.cdr = cdr;
    this.originalTimeOut = this.toastPackage.config.timeOut || 0;
  }

  protected getToastMessage(): string {
    return this.toastPackage?.message ?? this.message();
  }
}
